module.exports = __webpack_public_path__ + "img/SKLB-Artboard 1 copy.4b822c94.png";